import { render, staticRenderFns } from "./ScopevisioAuthDestination.vue?vue&type=template&id=9ca6dc98&"
import script from "./ScopevisioAuthDestination.vue?vue&type=script&lang=ts&"
export * from "./ScopevisioAuthDestination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports